import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum IncreDecreBookValSet {
  beginTerm = '1',
  beginTermEndFirstHalf = '2',
  endQuarter = '3',
  endPreviousMonth = '4',
  endMonth = '5',
}

const nameConfig = {
  beginTerm: new Map([
    [Locale.ja, '期首'],
    [Locale.en, 'Begin Term'],
  ]),

  beginTermEndFirstHalf: new Map([
    [Locale.ja, '期首上期末'],
    [Locale.en, 'Begin Term End First Half'],
  ]),

  endQuarter: new Map([
    [Locale.ja, '四半期末'],
    [Locale.en, 'End Quarter'],
  ]),

  endPreviousMonth: new Map([
    [Locale.ja, '前月末'],
    [Locale.en, 'End Previous Month'],
  ]),

  endMonth: new Map([
    [Locale.ja, '当月末'],
    [Locale.en, 'End Month'],
  ]),
};

const toEnum = rawValueToEnum(IncreDecreBookValSet, IncreDecreBookValSet.beginTerm);
const toDisplay = enumToName(IncreDecreBookValSet, nameConfig);
const toDisplayWithPrefix = enumToName(IncreDecreBookValSet, nameConfig, { prefix: true });

export const increDecreBookValSet = {
  enum: IncreDecreBookValSet,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { IncreDecreBookValSet };
